import(/* webpackMode: "eager" */ "/vercel/path0/apps/checkout/src/components/icons/header-icon.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.3_@babel+core@7.28.6_@opentelemetry+api@1.9.0_@playwright+test@1.57.0_babel-plugin-_6ajfppstd5pohoytmwf56j42te/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["NinjaWhite"] */ "/vercel/path0/packages/ui/components/platforms/ninja-white.tsx");
